import { AxiosRequestConfig, AxiosResponse } from 'axios';
import {
	PremiumReportCreateRequest,
	PremiumReportResponse,
	PremiumReportUpdateRequest,
} from '../types/premiumReports';
import { getApiUrl } from '../util/util';
import { get, patch, post } from './http';

interface PremiumReportingApi {
	createPremiumReport(
		authorizationToken: string,
		policyLocator: string,
		createReq: PremiumReportCreateRequest,
	): Promise<AxiosResponse<PremiumReportResponse>>;
	getPremiumReport(
		authorizationToken: string,
		premiumReportLocator: string,
	): Promise<AxiosResponse<PremiumReportResponse>>;
	getPremiumReports(
		authorizationToken: string,
		policyLocator: string,
		config?: AxiosRequestConfig<any>,
	): Promise<AxiosResponse<PremiumReportResponse[]>>;
	updatePremiumReport(
		authorizationToken: string,
		premiumReportLocator: string,
		updateReq: PremiumReportUpdateRequest,
	): Promise<AxiosResponse<PremiumReportResponse>>;
	issuePremiumReport(
		authorizationToken: string,
		premiumReportLocator: string,
	): Promise<AxiosResponse<PremiumReportResponse>>;
	reversePremiumReport(
		authorizationToken: string,
		premiumReportLocator: string,
	): Promise<AxiosResponse<PremiumReportResponse>>;
	replacePremiumReport(
		authorizationToken: string,
		premiumReportLocator: string,
		updateReq: PremiumReportUpdateRequest,
	): Promise<AxiosResponse<PremiumReportResponse>>;
	discardPremiumReport(
		authorizationToken: string,
		premiumReportLocator: string,
	): Promise<AxiosResponse<PremiumReportResponse>>;
}

export default {
	createPremiumReport(
		authorizationToken: string,
		policyLocator: string,
		createReq: PremiumReportCreateRequest,
	) {
		return post(
			`${getApiUrl()}/policies/${policyLocator}/premiumReports`,
			authorizationToken,
			createReq,
		);
	},
	getPremiumReport(authorizationToken: string, premiumReportLocator: string) {
		return get(
			`${getApiUrl()}/premiumReports/${premiumReportLocator}`,
			authorizationToken,
		);
	},
	getPremiumReports(
		authorizationToken: string,
		policyLocator: string,
		config?: AxiosRequestConfig<any>,
	) {
		return get(
			`${getApiUrl()}/policies/${policyLocator}/premiumReports`,
			authorizationToken,
			config,
		);
	},
	updatePremiumReport(
		authorizationToken: string,
		premiumReportLocator: string,
		updateReq: PremiumReportUpdateRequest,
	) {
		return patch(
			`${getApiUrl()}/premiumReports/${premiumReportLocator}`,
			authorizationToken,
			updateReq,
		);
	},
	issuePremiumReport(authorizationToken: string, premiumReportLocator: string) {
		return patch(
			`${getApiUrl()}/premiumReports/${premiumReportLocator}/issue`,
			authorizationToken,
		);
	},
	reversePremiumReport(
		authorizationToken: string,
		premiumReportLocator: string,
	) {
		return patch(
			`${getApiUrl()}/premiumReports/${premiumReportLocator}/reverse`,
			authorizationToken,
		);
	},
	replacePremiumReport(
		authorizationToken: string,
		premiumReportLocator: string,
		updateReq: PremiumReportUpdateRequest,
	) {
		return post(
			`${getApiUrl()}/premiumReports/${premiumReportLocator}/replace`,
			authorizationToken,
			updateReq,
		);
	},
	discardPremiumReport(
		authorizationToken: string,
		premiumReportLocator: string,
	) {
		return patch(
			`${getApiUrl()}/premiumReports/${premiumReportLocator}/discard`,
			authorizationToken,
		);
	},
} as PremiumReportingApi;
